import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChatOverlayComponent } from './chat-overlay.component';
//import { ConciergeModule } from '../../concierge/concierge.module';

@NgModule({
  declarations: [ChatOverlayComponent],
  imports: [CommonModule, FormsModule],
  exports: [ChatOverlayComponent]
})
export class ChatOverlayModule {}
